import React from 'react';
import ReservationCard from '../../portal/ReservationCard';
import ScheduleCard from "../../portal/ScheduleCard";
import WelcomeCard from '../../portal/WelcomeCard';
import WeatherCard from '../../portal/WeatherCard';
import ColumnChart from '../../portal/ColumnChartCard';
import PieChartCard from '../../portal/PieChartCard';
import RecentBoardsCard from '../../portal/RecentBoardsCard';
import RecentAprvDocsCard from '../../portal/RecentAprvDocsCard';
import RecentMailListCard from '../../portal/RecentMailListCard';
import RecentMailListCardImap from '../../portal/RecentMailListCard_imap';
import TodoCard from '../../portal/TodoCard';


import { getPosts } from '../../../api/boardApi';
import { getManagerPortletLabelByStoredValue } from '../../../utils/managerUtils';

/**
 * 포틀릿 Fallback 카드 (비어있거나 미구현 포틀릿에 표시)
 */
const EmptyPortletCard = ({ title }) => (
  <div className="card portal-card flex-grow-1">
    <div className="card-body d-flex align-items-center justify-content-center text-muted">
      {title || '포틀릿 없음'}
    </div>
  </div>
);

/**
 * 포틀릿 렌더러 레지스트리
 * - 포틀릿을 추가하려면 이 파일에 항목을 추가하세요.
 * - 각 렌더러는 (ctx) => JSX 형태의 함수입니다.
 * - ctx 객체: { currentUser }
 * - 신규 포틀릿이 추가될경우 PORTLET_RENDERERS에 portlet_id 값과 return 값을 추가
 */
export const PORTLET_RENDERERS = {

  myProfile: (ctx) => {
    const { currentUser } = ctx;
    return (
      <>
        <WelcomeCard currentUser={currentUser} />
        <WeatherCard />
      </>
    );
  },

  reservation: () => <ReservationCard />,

  schedule: () => <ScheduleCard />,

  chartTypeA: () => <ColumnChart />,

  chartTypeB: () => <PieChartCard />,

  test_p1: () => <EmptyPortletCard title=" 준비중 !!!!" />,

  test_p2: () => <EmptyPortletCard title=" 준비중 2222" />,

  recentBoard: () => (
    <RecentBoardsCard
      codeId="1"
      title="자유게시판 최신글"
      headers={['제목', '작성자', '작성일']}
      rowKeys={['title', 'writer_name', 'created_at']}
      limit={5}
      dataSource="api"
      fetchFn={getPosts}
    />
  ),

  recentAprv: () => (
    <RecentAprvDocsCard
      title="진행중 결재문서"
      headers={['제목', '기안자', '기안일']}
      rowKeys={['title', 'user_name', 'req_date']}
      limit={5}
    />
  ),

  recentMail: (ctx) => (
    <RecentMailListCard title="최근 메일" limit={5} ssoReady={ctx.ssoReady} />
  ),

  recentMail_imap: () => (
    <RecentMailListCardImap title="최근 메일(IMAP)" limit={5} />
  ),

  todolist: (ctx) => <TodoCard onShowOriginal={ctx?.onShowOriginal} />,

};

/**
 * portletId에 해당하는 포틀릿 컴포넌트를 렌더링합니다.
 * @param {string} portletId - 포틀릿 ID
 * @param {object} ctx - 렌더러에 전달할 컨텍스트 (예: { currentUser })
 */
export const renderPortletById = (portletId, ctx = {}) => {
  const renderer = PORTLET_RENDERERS[portletId];
  if (renderer) return renderer(ctx);
  return <EmptyPortletCard title={getManagerPortletLabelByStoredValue(portletId)} />;
};
